import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import styled from "styled-components";
import * as my from "./MyForm";

const InfoBoxText = styled.div`
    background-color: var(--it-bg-buttons);
    border-radius: 4px;
    padding: 1rem;
    
    white-space: wrap;
`

export const InfoBox = ({
                             className = '',
                             inline = false,
                             label = '',
                             labelBold = false,
                             flex = {},
                             text,
                             children,
                             ...rest
                         }) => {
  return (
    <my.Elemet data-inline={!!inline} className={`flex-auto ${className}`}>
      {!!label && (<my.Label data-inline={!!inline}>{label}</my.Label>)}

      <InfoBoxText>
        {text}
      </InfoBoxText>
    </my.Elemet>
  )
}
InfoBox.propTypes = {
    inline: PropTypes.bool,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
}
